import React from "react"
import Paper from "@mui/material/Paper"
import withStyles from "@mui/styles/withStyles"
import TableContainer from "@mui/material/TableContainer"
import Table from "@mui/material/Table"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import TableCell from "@mui/material/TableCell"
import TableBody from "@mui/material/TableBody"
import { getRecipeCostDataColumn } from "../../utils/recipes"
import { ACTIVE_KFC_BRANDS, COLORS } from "../../utils"

import { grey, green } from "@mui/material/colors"

const EnhancedTableHead = ({ classes, labels }) => {
    return (
        <TableHead>
            <TableRow>
                <TableCell classes={{ root: classes.headCell }} align="left">
                    <div style={{ color: grey[700] }}>Coûts</div>
                </TableCell>
                {
                    labels.map((label, index) =>
                        <TableCell
                            classes={{ root: classes.headCell }}
                            key={index}
                            align="right"
                        >
                            <div className={classes.headLabel}>{label}</div>
                        </TableCell>
                    )
                }
            </TableRow>
        </TableHead>
    )
}

const CostValue = ({ classes, value }) => {
    if (typeof value !== "object") {
        return <span className={classes.priceLabel}>{value}</span>
    }

    let pctClassName = classes.pctLabel
    if (value.hasOwnProperty("redPCT")) {
        pctClassName = parseFloat(value.pct) > value.redPCT ? classes.redPctLabel : classes.greenPctLabel
    }

    return (
        <>
            {value.hasOwnProperty("pct") && <span className={pctClassName}>{value.pct}</span>}
            <span className={classes.priceLabel}>{value.value}€</span>
        </>
    )
}

export const Cost = (props) => {
    const { classes, jsonRecipe } = props

    const brands = jsonRecipe && Array.isArray(jsonRecipe.brands)
        ? ACTIVE_KFC_BRANDS.filter(elem => jsonRecipe.brands.includes(elem.name))
        : []

    const data = getRecipeCostDataColumn(jsonRecipe)

    return (
        <Paper className={classes.container}>
            <TableContainer>
                <Table
                    className={classes.table}
                    aria-labelledby="tableTitle"
                    aria-label="enhanced table"
                >
                    <EnhancedTableHead
                        classes={classes}
                        labels={data.map(elem => elem.label)}
                    />
                    <TableBody>
                        {
                            brands.map((brand) => (
                                <TableRow key={brand.name} classes={{ root: classes.rowWithBorder }}>
                                    <TableCell align="left" classes={{ root: classes.cellLargePadding }}>
                                        <div className={classes.brandCellContent}>
                                            <img className={classes.cellHeadImage} src={brand.image} alt="logo" />
                                            <span style={{ color: brand.color || grey[700] }}>{brand.label}</span>
                                        </div>
                                    </TableCell>
                                    {
                                        data.map((elem, index) => (
                                            <TableCell key={index} align="right" classes={{ root: classes.cellLargePadding }}>
                                                <CostValue classes={classes} value={elem[brand.name]} />
                                            </TableCell>
                                        ))
                                    }
                                </TableRow>
                            ))
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    )
}

const styles = {
    container: {
        boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.05)",
        padding: "16px 32px",
        marginTop: 16,
        paddingBottom: 16,
        borderRadius: 5,
    },
    headCell: {
        padding: "16px 0px",
        fontSize: 18,
        fontWeight: "bold",
        color: "rgba(0, 0, 0, 0.87)"
    },
    headLabel: {
        fontSize: 14,
        color: grey[700],
        paddingLeft: 16
    },
    cellHeadImage: {
        marginRight: 8,
        width: 20,
        height: 20
    },
    brandCellContent: {
        display: "flex",
        alignItems: "center",
        whiteSpace: "nowrap",
        fontWeight: "bold",
        paddingRight: 16
    },
    cell: {
      borderBottom: "none"
    },
    cellWithoutBorder: {
        composes: "$cell",
        border: "none",
    },
    cellLargePadding: {
        composes: "$cell",
        padding: "10px 0px 10px 16px",
        whiteSpace: "nowrap"
    },
    rowWithBorder: {
        borderBottom: "1px solid rgba(224, 224, 224, 1)"
    },
    priceLabel: {
        fontSize: 14,
        color: grey[600],

    },
    pctLabel: {
        fontWeight: "bold",
        fontSize: 16,
        marginRight: 8
    },
    greenPctLabel: {
        composes: "$pctLabel",
        color: green[700]
    },
    redPctLabel: {
        composes: "$pctLabel",
        color: COLORS.RED_ERROR
    }
}

export default withStyles(styles)(Cost)
